import { id } from "./id";
import { state } from "./state";
import { filter, first, find } from "lodash-es";

export const getters = defineStoreGetters(
  { id, state },
  {
    getBannerByPageAndLocation(state) {
      return (page: string, location: string) => {
        return first(
          filter(
            state.banners,
            (el) => el.page === page && el.location === location,
          ),
        );
      };
    },
    getVideoProgress(state) {
      return (id: string) => {
        return find(state.videoProgress, (el) => el.id === id);
      };
    },
  },
);
